import "./index.css";
const Loading = () => {
  return (
    <div className="loader"></div>
  );
};
export default Loading;
